const LoanChallenge1InitialText ="Now that you have had a chance to use the loan calculator to " +
    "understand how the loan factors affect payment amounts, you can use that knowledge " +
    "to classify the loans.  Move the loans from the 'Loan Parameters' column to the "  +
    "correct column.  Only one loan can be moved to a given column. The 'overpay' amount " +
    "is defined as the total amount that is paid for a loan minus the amount of the loan. " +
    "Example:  If you have a monthly payment of $50.00 for 10 months, you will have paid  " +
    "$500.00.  If the original loan amount was $400.00, then the overpay amount is $100.00. " +
    "When you have finished moving a loan into each column, click the 'Done' button." 
 
export default LoanChallenge1InitialText